"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const polished_1 = require("polished");
const _1 = require("../.");
/**
 * A list of selectable options, where each one is represented by an image and
 * text.
 */
const ImageSelect = ({ name, value, mandatory, setValue, options, multiple, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.ImageSelect }, options.map((option, index) => {
        const checked = (value && multiple ? value.includes(option.value) : value === option.value);
        return (react_1.default.createElement("div", { key: index, className: (0, classnames_1.default)(classes.input, { [classes.isChecked]: checked }), onClick: () => {
                const finalValue = multiple ? (0, _1.checkboxHandler)(!checked, option.value, value) : option.value;
                setValue(name, finalValue, mandatory, { touched: true });
            } },
            react_1.default.createElement("img", { src: option.image, alt: '' }),
            option.label && react_1.default.createElement("span", { className: classes.label }, option.label)));
    })));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    ImageSelect: {
        display: 'flex',
        alignItems: 'center',
    },
    input: {
        flex: '65px 0 0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 9,
        lineHeight: 'normal',
        marginTop: 5,
        marginBottom: 10,
        padding: '0 1px',
        color: theme.colors.inputText,
        cursor: 'pointer',
        position: 'relative',
        zIndex: 1,
    },
    label: {
        marginTop: 6,
        paddingBottom: 2,
    },
    isChecked: {
        '&:before': {
            content: '""',
            position: 'absolute',
            top: -5,
            right: 1,
            bottom: -5,
            left: 1,
            backgroundColor: (0, polished_1.lighten)(0.6, theme.colors.accent),
            border: `2px solid ${theme.colors.accent}`,
            borderRadius: theme.sizes.borderRadius,
            zIndex: -1,
        },
    },
}));
exports.default = (0, _1.withFormControl)(ImageSelect);
